
import { StatusChip } from './GridActions';
export const userColumns = [
    // { field: "userId", headerName: "userId", width: 70 },
    {
        field: "name",
        headerName: "ชื่อ",
        width: 150,
    },
    {
        field: "username",
        headerName: "ชื่อเข้าใช้ระบบ",
        width: 150,
    },
    {
        field: "employeeId",
        headerName: "รหัสพนักงาน",
        width: 100,
    },
    {
        field: "departmentname",
        headerName: "แผนก",
        width: 160,
    },
    {
        field: "positionname",
        headerName: "ตำแหน่ง",
        width: 160,
    },
    // {
    //     field: "email",
    //     headerName: "email",
    //     width: 160,
    // },
    {
        field: "roles",
        headerName: "กลุ่มผู้ใช้",
        width: 160,
    },
    // {
    //     field: "menugroupId",
    //     headerName: "menugroupId",
    //     width: 160,
    // },

    {
        field: "isActive",
        headerName: "สถานะ",
        width: 100,
        renderCell: (params) => {
            return (
              params.row.isActive == 1
                ? <StatusChip label="เปิดใช้งาน" color="#2e7d32" bg="#e3f6e5" />
                : <StatusChip label="ปิดใช้งาน" color="#c62828" bg="#fdecec" />
            );
          },
    },
    
];